<div class="row" [ngClass]="accessedFromSettings ? '' : 'mt-3'">
  <div class="col d-flex justify-content-between">
    <h2 class="d-inline float-left">{{ 'Packages.AddPackageFromLibrary' | translate }}</h2>
    <div>
      <button class="btn btn-outline-success" (click)="packageToOffer()" [disabled]="!packageChosen" *ngIf="mode == 'offer'"  data-dismiss="modal" data-target="#copyPackagesModal">{{ 'Vælg pakke' | translate }}</button>
      <button class="btn btn-outline-success ml-3" (click)="prepareCopy()" data-toggle="modal" data-target="#copyPackagesModal" [disabled]="selectedPackages.length == 0" *ngIf="mode != 'offer'">{{ 'Kopier valgte' | translate }}</button>
      <button [routerLink]="['../']" class="btn btn-outline-primary ml-3" *ngIf="mode != 'offer'">{{ 'Buttons.Back' | translate }}</button>
    </div>
  </div>
</div>
<hr />

<div class="row">
  <div class="col-2 pr-0">
    <h3>Pakkepartnere</h3>
    <ul class="list-group">
      <li class="list-group-item d-flex justify-content-between align-items-center pl-1 pr-1 pl-xl-2 pr-xl-2" *ngFor="let x of libraryPartners" (click)="getCategories(x.companyId, x.name); activeCompany = x.companyId" [ngClass]="activeCompany == x.companyId ? 'active' : ''">
        <span class="partnerLabelText">
          <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x?.imgUrl }}" alt="Package partner logo" class="libraryPartners mr-2">
          {{ x.name }}
        </span>
      </li>
    </ul>
  </div>
  <div class="col-2 pr-0">
    <h3>Kategorier</h3>
    <ul class="list-group">
      <li class="list-group-item d-flex justify-content-between align-items-center pl-1 pr-1 pl-xl-2 pr-xl-2" *ngFor="let x of categories" (click)="getPackages(x.categoryId); activeCategory = x.categoryId" [ngClass]="activeCategory == x.categoryId ? 'active' : ''">
        <div class="custom-control custom-checkbox" *ngIf="mode != 'offer'">
          <input type="checkbox" class="custom-control-input" id="customCheck-{{ x.categoryId }}" [checked]="selectedCategories.includes(x.categoryId)">
          <label class="custom-control-label" for="customCheck1-{{ x.categoryId }}" (click)="chooseCategory(x.categoryId)"></label>
          <span class="labelText">{{ x.categoryName }}</span>
        </div>
        <span class="labelText" *ngIf="mode == 'offer'">{{ x.categoryName }}</span>
        <span class="badge badge-primary badge-pill posRight" *ngIf="mode != 'offer'">{{ x.packageCount }}</span>
      </li>
    </ul>
  </div>
  <div class="col-2 pr-0">
    <h3>Pakker</h3>
    <ul class="list-group" *ngIf="showPackages">
      <li class="list-group-item d-flex justify-content-between align-items-center w-100 pl-1 pr-1 pl-xl-2 pr-xl-2" *ngFor="let x of categoryPackages" (click)="getPackage(x.packageId); activePackage = x.packageId" [ngClass]="activePackage == x.packageId ? 'active' : ''">
        <div class="custom-control custom-checkbox" *ngIf="mode != 'offer'">
          <input type="checkbox" class="custom-control-input" id="customCheck-{{ x.packageId }}" [checked]="isPackageSelected(x.packageId)">
          <label class="custom-control-label" for="customCheck1-{{ x.packageId }}" (click)="choosePackages(x)"></label><span class="labelTextWithImage">{{ x.name }}</span>
        </div>
        <span class="labelTextWithImage labelTextOffer" *ngIf="mode == 'offer'">{{ x.name }}</span>
        <span class="posRight"><img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ x?.imgUrl }}" alt="Package image" class="packageImg"></span>
      </li>
    </ul>
  </div>
  <div class="col-6">
    <h3>Pakkedetajer</h3>
    <div class="card" *ngIf="showDetails">
      <div class="card-body pl-1 pr-1 pl-xl-2 pr-xl-2">
        <div class="row">
          <div class="col-12">
            <h5 class="card-title">{{ packageDetails.name }}</h5>
          </div>
          <div class="col-8">
            <p class="card-text" [innerHtml]="packageDetails.description"></p>
            <h5 class="card-title" *ngIf="!!packageDetails.productLines">Materialer</h5>
            <ul *ngIf="!!packageDetails.productLines">
              <li *ngFor="let x of packageDetails.productLines">{{ x.description }}</li>
            </ul>
            <ul *ngIf="!!packageDetails.customLines">
              <li *ngFor="let x of packageDetails.customLines">{{ x.description }}</li>
            </ul>
            <h5 class="card-title">Installationstid</h5>
            <p>{{ packageDetails.installationTimeInHours }} timer</p>
            <h5 class="card-title">Forbehold</h5>
            <p class="card-text" [innerHtml]="packageDetails.disclaimer"></p>
          </div>
          <div class="col-4">
            <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ packageDetails.imageUrl }}" alt="Package image" class="card-img-top card-img-top-packageDetails mx-auto mt-2">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <h5 class="card-title">Total pris <i class="help-text">Prisen udregnes med dine kostpriser og tillægges automatisk dine avancer når pakken overføres</i></h5>
          </div>
          <div class="col-4">
            <p class="mb-1">Kostpris: {{ priceCalc(packageDetails.costPrice) }}</p>
          </div>
          <div class="col-4">
            <p class="mb-1">Salgspris ex. moms: {{ priceCalc(packageDetails.salesPrice) }}</p>
          </div>
          <div class="col-4">
            <p>Salgspris inkl. moms: {{ priceCalc(packageDetails.salesPrice + packageDetails.salesVat) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade bd-example-modal-lg" id="copyPackagesModal" tabindex="-1" role="dialog" aria-labelledby="copyPackagesModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="copyPackagesModalLabel">Kopier pakker</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-body row">
        <div class="form-group col-6">
          <label for="skill">Vælg kompetence</label>
          <select class="form-control" id="skill" [(ngModel)]="selectedSkill">
            <option *ngFor="let x of skills" value="{{ x.skillId }}">{{ x.name }}</option>
          </select>
        </div>
        <div class="form-group col-6">
          <label for="pricegroup">Vælg prisgruppe</label>
          <select class="form-control" id="pricegroup" [(ngModel)]="selectedPriceGroup">
            <option *ngFor="let x of priceGroups" value="{{ x.priceGroupId }}">{{ x.name }}</option>
          </select>
        </div>
        <div class="form-group col-12">
          <div class="row">
            <div class="col-4">
              <p class="label-header">Partner kategori</p>
            </div>
            <div class="col-4">
              <p class="label-header">Min kategori</p>
            </div>
            <div class="col-4">
              <p class="label-header">Ny kategori</p>
            </div>
          </div>
          <div class="row mb-2" *ngFor="let x of importToCategory; let i = index">
            <div class="col-4">
              <input type="text" class="form-control" id="partnerCategoryList" value="{{ x.name }}" disabled>
            </div>
            <div class="col-8">
              <div class="row">
                <div class="col-6">
                  <select class="form-control" id="companyCategoryList" [(ngModel)]="x.companyCategoryId">
                    <option *ngFor="let y of companyCategories" value="{{ y.categoryId }}">{{ y.name }}</option>
                  </select>
                </div>
                <div class="col-6 d-flex">
                  <button type="button" class="btn btn-primary" *ngIf="!x.newCategory" (click)="x.newCategory = true;">Tilføj ny kategori</button>
                  <input type="text" class="form-control" placeholder="Kategori navn" *ngIf="x.newCategory" [(ngModel)]="x.newCategoryName">
                  <button type="button" class="btn btn-success addNewBtn" (click)="addNewCategory(i)" *ngIf="x.newCategory">+</button>
                  <button type="button" class="btn btn-danger addNewBtn" (click)="x.newCategory = false" *ngIf="x.newCategory">×</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="startPackageTransfer()" data-dismiss="modal" [disabled]="validator()">Save changes</button>
      </div>
    </div>
  </div>
</div>



